import React from 'react';

import { Wrapper } from './Block.jsx';
import { EmptyPlaceholder } from '../utility/blocks';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import { Email } from '../../components/repositories/Type.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

import { default as ClickToken } from '../../../../../artcloud.click/source/scripts/common/Token.jsx';

function ContactMetaComponent(props) {
    const _data = (props) => {
        let data = props.data || {};
        if (data.Contact) {
            data = data.Contact;
        }
        return data;
    }
    const parseContent = (props, tokenizedString) => {
        if (!tokenizedString) {
            return '';
        }
        // const data = props.data || {};
        const data = _data(props);
        return ClickToken.parseTokenizedString(tokenizedString, (keyword, options) => {
            let replaceString = '';
            switch (keyword) {
                case Token.Contact.Email:
                    if (data.Email && data.Email.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Email, options);
                    }
                    break;
                case Token.Contact.Message:
                    if (data.Message && data.Message.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Message, options);
                    }
                    break;
                case Token.Contact.Name:
                    if (data.Name && data.Name.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Name, options);
                    }
                    break;
                case Token.Contact.Offer.Amount:
                    if (data.OfferAmount && data.OfferAmount.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.OfferAmount, options);
                    }
                    break;
                case Token.Contact.Offer.Discount:
                    if (data.OfferDiscount && data.OfferDiscount.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.OfferDiscount, options);
                    }
                    break;
                case Token.Contact.Offer.Percent:
                    if (data.OfferPercent && data.OfferPercent.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.OfferPercent, options);
                    }
                    break;
                case Token.Contact.Phone:
                    if (data.Phone && data.Phone.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.Phone, options);
                    }
                    break;
                case Token.FirstName:
                    if (data.FirstName && data.FirstName.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.FirstName, options);
                    }
                    break;
                case Token.LastName:
                    if (data.LastName && data.LastName.length > 0) {
                        replaceString = ClickToken.getReplacementString(data.LastName, options);
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            if (replaceString == '' && options && options.default && options.default.length > 0) {
                replaceString = options.default;
                if (replaceString.trim().length == 0) {
                    replaceString = '&nbsp;'
                }
            }
            return replaceString;
        });
    }
    const data = _data(props);
    const design = props.blockConfig && props.blockConfig.block && props.blockConfig.block.design;
    const [content, setContent] = React.useState(undefined);
    React.useEffect(() => {
        setContent(parseContent(props, props.blockConfig.block.design));
    }, [data.ClientId, design]);

    if (props.serverSide && content == undefined) {
        setContent(parseContent(props, props.blockConfig.block.design));
    }
    if (!props.builder && content != undefined && content.length == 0) {
        return null;
    }
    const { contentContainerStyle, contentStyle, innerStyle, wrapperStyle } = Utilities.parseTextWrapperConfig(props.blockConfig);
    return (
        <Wrapper {...props} className="SharedCaptionBlock" style={wrapperStyle}>
            <td align="center" className="SharedCaptionBlockInner" style={innerStyle} valign="top">
                <table
                    align="center"
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="SharedCaptionBottomContent"
                    style={contentContainerStyle}
                    width={props.maxWidth}>
                    <tbody>
                        <tr>
                            <td
                                className="SharedTextContent"
                                style={contentStyle}
                                valign="middle">
                                {
                                    content != undefined &&
                                    <div dangerouslySetInnerHTML={{ __html: content }} style={{ lineHeight: 1 }} />
                                }
                                {
                                    props.builder &&
                                    (content == undefined || content.length == 0) &&
                                    <EmptyPlaceholder fullWidth={true} />
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    );
}
const ContactMetaTokens = (context) => {
    let tokens = [
        Token.getWrappedTokenConfig('Full Name', Token.Contact.Name, false),
        Token.getWrappedTokenConfig('First Name', Token.FirstName, false),
        Token.getWrappedTokenConfig('Last Name', Token.LastName, false),
        Token.getWrappedTokenConfig('Email', Token.Contact.Email, false),
        Token.getWrappedTokenConfig('Phone', Token.Contact.Phone, false)
    ];
    switch (context) {
        case Email.Offer:
            tokens.push(Token.getWrappedTokenConfig('Offer Amount', Token.Contact.Offer.Amount, false));
            tokens.push(Token.getWrappedTokenConfig('Offer Discount', Token.Contact.Offer.Discount, false));
            tokens.push(Token.getWrappedTokenConfig('Offer Percent', Token.Contact.Offer.Percent, false));
            break;
        case Email.Subscribe:
            // No additional tokens
            break;
        default:
            tokens.push(Token.getWrappedTokenConfig('Message', Token.Contact.Message, false));
            break;
    }
    return tokens;
}
const ContactMetaTypeConfig = {
    defaultDesign: `<p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Contact.Name}">{${Token.Contact.Name}("before":"","after":"")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Contact.Email}">{${Token.Contact.Email}("before":"","after":"")}</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Contact.Phone}">{${Token.Contact.Phone}("before":"","after":"")}</span></p>`,
    defaultDesignMessage: `<p class="p" style="margin:0;padding:0;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Contact.Message}">{${Token.Contact.Message}("before":"","after":"")}</span></p>`,
    defaultDesignOffer: `<p class="p" style="margin:0;padding:0;"><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;">We will take your offer of </span><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;" token="${Token.Contact.Offer.Amount}">{${Token.Contact.Offer.Amount}("before":"","after":"")}</span><span style="font-family:${TypeConfig.defaultFontFamily};font-size:16px;line-height:24px;vertical-align:middle;"> into consideration and a representative will reach out soon.</span></p>`,
    panel: {
        block: function (defaultDesign) {
            const group = 'block';
            return {
                group,
                label: 'Content',
                options: [
                    {
                        display: 'Design contact meta here',
                        group,
                        name: 'design',
                        type: 'rich-text-campaign-short',
                        value: defaultDesign || ContactMetaTypeConfig.defaultDesign
                    },
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color'
                    },
                    {
                        display: 'Content Background Color',
                        group,
                        name: 'contentColor',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    }
                ]
            };
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '9', unit: 'px' },
                            paddingTop: { value: '9', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
}

const ContactMessageBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.Contact.Message,
        config: {
            block: ContactMetaTypeConfig.panel.block(ContactMetaTypeConfig.defaultDesignMessage),
            layout: ContactMetaTypeConfig.panel.layout()
        },
        display: 'Contact Message',
        group,
        image: 'contact_message.png'
    };
}

const ContactMetaBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.Contact.Text,
        config: {
            block: ContactMetaTypeConfig.panel.block(),
            layout: ContactMetaTypeConfig.panel.layout()
        },
        display: 'Contact Meta Text',
        group,
        image: 'contact_meta_text.png'
    };
}

const ContactOfferBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.Contact.Offer,
        config: {
            block: ContactMetaTypeConfig.panel.block(ContactMetaTypeConfig.defaultDesignOffer),
            layout: ContactMetaTypeConfig.panel.layout()
        },
        display: 'Offer Details',
        group,
        image: 'contact_offer.png'
    };
}

export { 
    ContactMessageBlockTypeDefinition, 
    ContactMetaBlockTypeDefinition, 
    ContactMetaComponent, 
    ContactMetaTokens, 
    ContactMetaTypeConfig,
    ContactOfferBlockTypeDefinition
}